import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "formBorder" }
const _hoisted_2 = { class: "single-search-header" }
const _hoisted_3 = { class: "single-search" }
const _hoisted_4 = { class: "single-search-input" }
const _hoisted_5 = { class: "single-search-button" }
const _hoisted_6 = { class: "multiple-search" }
const _hoisted_7 = { style: {"position":"fixed","bottom":"0","right":"0","font-size":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_advanced_search = _resolveComponent("advanced-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_b_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, {
              cols: "2",
              class: _normalizeClass(['search-tab', {'tab-active': _ctx.state.tab === 'single'}]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayTab('single')))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("label", null, "Single", -1)
              ])),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_b_col, {
              cols: "2",
              class: _normalizeClass(['search-tab', {'tab-active': _ctx.state.tab === 'multiple'}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayTab('multiple')))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("label", null, "Multiple", -1)
              ])),
              _: 1
            }, 8, ["class"]),
            _withDirectives(_createVNode(_component_b_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.openNewTab,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openNewTab) = $event)),
                  style: {"padding-top":"5px"},
                  label: "Open in new tab",
                  onChange: _ctx.saveOpenPreference
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.state.tab === 'multiple']
            ])
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_2, _cache[6] || (_cache[6] = [
        _createElementVNode("div", { style: {"margin-right":"15%"} }, " Search by Proposal Number ", -1)
      ]), 512), [
        [_vShow, _ctx.state.tab === 'single']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_form_input, {
            type: "number",
            modelValue: _ctx.state.searchValueOneProposal,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.searchValueOneProposal) = $event)),
            placeholder: "Proposal number..."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_button, {
            type: "submit",
            variant: "primary",
            onClick: _ctx.handleSearchProposal,
            disabled: !_ctx.state.searchValueOneProposal > 0
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Search ")
            ])),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ], 512), [
        [_vShow, _ctx.state.tab === 'single']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_component_advanced_search, {
          "action-name": _ctx.actionName,
          onSelect: _ctx.emitSelection
        }, null, 8, ["action-name", "onSelect"])
      ], 512), [
        [_vShow, _ctx.state.tab === 'multiple']
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", null, "v." + _toDisplayString(_ctx.version), 1)
    ])
  ], 64))
}